export default __webpack_public_path__ + "static/media/1840.bcb22415.png";